import filterInstructions from "./filterInstructions";
import parseInstructions from "./parseInstructions";

export default function reduceInstructions(ingredients, instructions, settings, config) {
  // destructure settings
  const { filterId } = settings;
  // destructure config
  const { filter, units } = config;

  // if there is a filterId, filter the instructions
  const filteredInstructions = filterId ? 
    filterInstructions(instructions, filterId, filter)
    : instructions;

  // parse instructions to include ingredient amounts
  return parseInstructions(filteredInstructions, ingredients, units);
}